import "./LanguageSwitcher.css";
import { useTranslation } from "../../i18n";

const LOCALE_OPTIONS = [
    { code: "zh", labelKey: "language.zh" },
    { code: "yue", labelKey: "language.yue" },
    { code: "en", labelKey: "language.en" },
];

function LanguageSwitcher({ className = "", compact = false }) {
    const { locale, setLocale, t } = useTranslation();

    return (
        <div
            className={`language-switcher${compact ? " language-switcher--compact" : ""} ${className}`.trim()}
            role="group"
            aria-label={t("language.label")}
        >
            {LOCALE_OPTIONS.map((option, index) => (
                <span key={option.code} className="language-switcher__item">
                    {index > 0 && (
                        <span className="language-switcher__sep" aria-hidden="true">
                            /
                        </span>
                    )}
                    <button
                        type="button"
                        className={`language-switcher__btn${locale === option.code ? " language-switcher__btn--active" : ""}`}
                        onClick={() => setLocale(option.code)}
                        aria-pressed={locale === option.code}
                    >
                        {t(option.labelKey)}
                    </button>
                </span>
            ))}
        </div>
    );
}

export default LanguageSwitcher;
